import { LoadingSpinnerComponent } from '@/components/loading-spinner/loading-spinner';
import { MoviePosterComponent } from '@/components/movie-poster/movie-poster';
import { AnalyticsPageCategories } from '@/enums/analytics-type';
import { useMovie } from '@/hooks/content/movies';
import { movieToMoviePoster } from '@/utils/movie-helper';
import { IdentifiableItemReference } from '@cinemark/content-api-client';

type MovieConverterHandlerComponentProps = {
  value: IdentifiableItemReference;
};

export const MovieConverterHandlerComponent = ({ value }: MovieConverterHandlerComponentProps): React.JSX.Element | null => {
  if (!value || typeof value !== 'object') return null;

  const { data: movie, isLoading } = useMovie(value.id || '');

  if (isLoading) {
    return <LoadingSpinnerComponent center="within-full" />;
  }

  if (!movie) return null;

  const moviePoster = {
    ...movieToMoviePoster(movie, AnalyticsPageCategories.CONTENT_PAGE),
    dataLinkName: `Movie - ${movie.movieTitle ?? movie.slug ?? value.id}`,
  };

  return (
    <div className="my-ms">
      <MoviePosterComponent showTitle
        dataLinkCategory={AnalyticsPageCategories.CONTENT_PAGE}
        dataLinkName={moviePoster.dataLinkName}
        movie={moviePoster}
        posterClassName="max-w-[250px]"
        showWatchlistButton={!!moviePoster.cinemarkMovieId}
      />
    </div>
  );
};
